
//Add anything from https://videojs.com/guides/options into this class if needed
export class Options{
    fluid:boolean;
    aspectRatio:string;
    autoplay:boolean;
    sources:Source [];
    height:string;
    width:string;
    controls:boolean;
    fill:boolean;
    children: string[];
    preload: string;
    muted:boolean;
    poster:string;
    audioPosterMode:boolean;
    controlBar: {
        children: String [
        ]
      }


}
export class Source{
    src:string;
    type: string;
}
